import { render, staticRenderFns } from "./FreemiumLockedAlert.vue?vue&type=template&id=f71c323a"
import script from "./FreemiumLockedAlert.vue?vue&type=script&lang=js"
export * from "./FreemiumLockedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports